// src/components/Fields/ImagePreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import DraggablePreviewWrapper from './DraggablePreviewWrapper';  // Ensure the path is correct
import { useFormLayout } from '../../contexts/FormLayoutContext'; // Adjust path as necessary

const ImagePreview = ({ id, index }) => {
    const { showDropZones, setShowDropZones } = useFormLayout();  // Use context to manage showDropZones

    // Render component with setShowDropZones passed to DraggablePreviewWrapper
    return (
        <DraggablePreviewWrapper
            id={id}
            type="image"
            index={index}
            isNew={true}
            showDropZones={showDropZones} // Pass down showDropZones state
            setShowDropZones={setShowDropZones} // Pass down setShowDropZones function
        >
            <Box display="flex" alignItems="center">
                <ImageIcon sx={{ fontSize: '0.95rem', marginRight: '8px', color: '#455A64' }} />
                <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}>
                    Image
                </Typography>
            </Box>
        </DraggablePreviewWrapper>
    );
};

export default ImagePreview;
